import { AddTeamMenu } from './AddTeamMenu';

export const NoTeamsOrRoomsView = () => {
  return (
    <div className="flex justify-center w-full">
      <AddTeamMenu />
    </div>
  );
};
